<template>
  <InputNumber
    :currency="currency"
    :currency-display="effectiveCurrencyDisplay"
    mode="currency"
    use-grouping
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import { Currency } from '@rygen/rygen-ui/model';

import InputNumber from 'primevue/inputnumber';

export interface InputCurrencyProps {
  currency: Currency | string | undefined;
  currencyDisplay?: 'symbol' | 'code';
}

const props = withDefaults(defineProps<InputCurrencyProps>(), {
  currency: () => Currency.USD,
  currencyDisplay: undefined,
});

const effectiveCurrencyDisplay = computed(() => {
  if (props.currencyDisplay) {
    return props.currencyDisplay;
  }
  return props.currency === Currency.USD ? 'symbol' : 'code';
});
</script>
